export const BRAND_IDENTITY_TABS = [
  { value: "colors", label: "Colors" },
  { value: "fonts", label: "Fonts" },
] as const;

export const BRAND_IDENTITY_FORM_ID = "brand-identity-form";

export const BRAND_IDENTITY_NOTICE = "Changing these settings may affect configurations using it.";
